import axios from "axios";
import moment from "moment";
export default {
  state: {
    contabili: [],
  },
  getters: {
    get_contabili: (state) => {
      return state.contabili;
    },
    get_contabile_by_id: (state) => (id) => {
      return state.contabili.find((contabile) => contabile.id == id);
    },
    get_contabile_by_id_ordine: (state) => (id_ordine) => {
      return state.contabili.find(
        (contabile) => contabile.id_ordine == id_ordine
      );
    },
    get_max_contabile_ddt: (state) => {
      // Ottieni l'anno corrente (ultime 2 cifre)
      const currentYear = moment().format("YY");
      let max_ddt = 0;
      
      state.contabili.forEach((contabile) => {
        if (contabile.ddt) {
          // le contabili sono salvate come numero/anno
          const parts = contabile.ddt.split("/");
          const ddt_num = parseInt(parts[0]);
          const ddt_year = parts[1];
          
          // Considera solo le contabili dell'anno corrente
          if (ddt_year === currentYear && ddt_num > max_ddt) {
            max_ddt = ddt_num;
          }
        }
      });
      
      // Restituisce il ddt maggiore trovato per l'anno corrente
      return max_ddt;
    },
    get_contabili_non_saldate_by_cliente: (state) => (cliente) => {
      return state.contabili.filter(
        (contabile) => contabile.cliente == cliente && !contabile.saldato
      );
    },
  },
  mutations: {
    set_contabili(state, contabili) {
      state.contabili = contabili;
    },
    set_contabile_eliminato(state, id) {
      let index = state.contabili.findIndex((contabile) => contabile.id == id);
      state.contabili.splice(index, 1);
    },
    add_contabile(state, contabile) {
      state.contabili.push(contabile);
    },
    update_contabile(state, contabile) {
      let index = state.contabili.findIndex((cont) => cont.id == contabile.id);
      if (index >= 0) {
        state.contabili.splice(index, 1, contabile);
      }
    },
    set_contabile_saldato(state, payload) {
      let contabile = state.contabili.find(
        (contabile) => contabile.id == payload.id
      );
      contabile.saldato = payload.stato;
    },
  },
  actions: {
    fetch_contabili(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/inizio/" +
        payload.inizio +
        "/fine/" +
        payload.fine;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((res) => {
            context.commit("set_contabili", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete_contabile(context, id) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, {
            auth: auth,
          })
          .then((response) => {
            context.commit("set_contabile_eliminato", id);
            // Se il debito eliminato consumava uno o più crediti (Pagamento
            // Cliente / Fattura Anticipata), il loro residuo si è appena
            // liberato: aggiorna subito le loro righe.
            if (response.data && response.data.crediti_aggiornati) {
              response.data.crediti_aggiornati.forEach((credito) => {
                context.commit("update_contabile", credito);
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    create_contabile(context, contabile) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, contabile, {
            auth: auth,
          })
          .then((response) => {
            context.commit("add_contabile", response.data);
            // Se il debito appena creato erode un credito esistente, il
            // residuo di quel credito è appena cambiato: aggiorna subito
            // la sua riga, senza aspettare un refresh completo.
            if (response.data.credito_aggiornato) {
              context.commit("update_contabile", response.data.credito_aggiornato);
            }
            // Un Pagamento Cliente che copre subito debiti esistenti: le
            // loro righe sono appena cambiate (saldato/residuo).
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    toggle_contabile_saldato(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/" + payload.id + "/saldato";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(
            url,
            { stato: payload.stato },
            {
              auth: auth,
              // Una richiesta che resta appesa (connessione instabile) deve
              // comunque risolversi in errore entro un tempo ragionevole,
              // così la UI non resta "spuntata" senza conferma dal server.
              timeout: 15000,
            }
          )
          .then((response) => {
            context.commit("update_contabile", response.data);
            // Se questa contabile è un credito/fattura anticipata con
            // debiti vincolati, il backend ha appena propagato lo stesso
            // saldato a cascata su di loro: aggiorna anche le loro righe.
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    update_contabile(context, contabile) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + contabile.id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, contabile, {
            auth: auth,
          })
          .then((response) => {
            context.commit("update_contabile", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SOCKET_CONTABILI_CHANGED(context) {
      context.dispatch("fetch_contabili", {
        inizio: moment().subtract(360, "days").format("X"),
        fine: moment().format("X"),
      });
    },
    // ALLOCAZIONI: copertura di un debito con un pagamento fresco e/o
    // erodendo un credito (nota di credito / fattura anticipata).
    crea_allocazione(context, { id_debito, ...payload }) {
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/" + id_debito + "/allocazioni";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, payload, { auth: auth, timeout: 15000 })
          .then((response) => {
            if (response.data.debito) {
              context.commit("update_contabile", response.data.debito);
            }
            if (response.data.credito_aggiornato) {
              context.commit("update_contabile", response.data.credito_aggiornato);
            }
            // Rata di pagamento su una Fattura Anticipata a rate (round
            // 53-bis): la fattura stessa aggiornata, e se il suo saldato
            // è appena cambiato, i debiti verdi che finanzia a cascata.
            if (response.data.fattura) {
              context.commit("update_contabile", response.data.fattura);
            }
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // Suddivide il residuo del piano di pagamento di una Fattura a rate
    // (round 54-bis) in N Allocazioni pianificate (saldato=False),
    // opzionalmente con scadenze auto-generate a intervalli (round 56-ter).
    crea_rate_pianificate(context, { id_fattura, numero_rate, scadenza_iniziale, intervallo_giorni }) {
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/" + id_fattura + "/rate_pianificate";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(
            url,
            { numero_rate, scadenza_iniziale, intervallo_giorni },
            { auth: auth, timeout: 15000 }
          )
          .then((response) => {
            if (response.data.fattura) {
              context.commit("update_contabile", response.data.fattura);
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    // Imposta/rimuove la scadenza prevista di una singola rata (round
    // 56-ter) — puramente informativa, non tocca saldato/realizzato.
    set_scadenza_allocazione(context, { id_fattura, id, scadenza }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/" +
        id_fattura +
        "/allocazioni/" +
        id +
        "/scadenza";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, { scadenza }, { auth: auth, timeout: 15000 })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    // Corregge la data di incasso (ts_saldo) di una rata già saldata
    // (round 65-undecies) — non tocca saldato/metodo, solo la data. Si
    // propaga ai debiti verdi finanziati dalla fattura (round
    // 65-quaterdecies: il loro ts_saldo è la più recente tra le date di
    // incasso che li coprono, quindi una correzione qui li aggiorna).
    set_ts_saldo_allocazione(context, { id_fattura, id, ts_saldo }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/" +
        id_fattura +
        "/allocazioni/" +
        id +
        "/ts_saldo";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, { ts_saldo }, { auth: auth, timeout: 15000 })
          .then((response) => {
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    // Corregge la data (ts) di una copertura "normale" già registrata su
    // un Debito (round 65-octovicies) — pagamento fresco o erosione di
    // credito, non una rata (per quello c'è set_ts_saldo_allocazione).
    // Si propaga al debito coperto: il suo ts_saldo può spostarsi (round
    // 65-quaterdecies).
    set_ts_allocazione(context, { id_debito, id, ts }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/" +
        id_debito +
        "/allocazioni/" +
        id +
        "/ts";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, { ts }, { auth: auth, timeout: 15000 })
          .then((response) => {
            if (response.data.debito) {
              context.commit("update_contabile", response.data.debito);
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    // Corregge il metodo di pagamento di una copertura "normale" (pagamento
    // fresco) già registrata su un Debito (round 65-tricies) — non
    // applicabile a un'erosione di credito, il backend la rifiuta.
    set_metodo_allocazione(context, { id_debito, id, metodo_pagamento }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/" +
        id_debito +
        "/allocazioni/" +
        id +
        "/metodo";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, { metodo_pagamento }, { auth: auth, timeout: 15000 })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    // Segna una singola rata pianificata come pagata/non pagata (round
    // 54-bis) — propaga il saldato della fattura e, a cascata, dei debiti
    // verdi che finanzia.
    set_saldato_allocazione(context, { id_fattura, id, stato, metodo_pagamento }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/" +
        id_fattura +
        "/allocazioni/" +
        id +
        "/saldato";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, { stato, metodo_pagamento }, { auth: auth, timeout: 15000 })
          .then((response) => {
            if (response.data.fattura) {
              context.commit("update_contabile", response.data.fattura);
            }
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    fetch_allocazioni_contabile(context, id) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + id + "/allocazioni";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    elimina_allocazione(context, id) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/allocazioni/" + id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, { auth: auth })
          .then((response) => {
            if (response.data.debito) {
              context.commit("update_contabile", response.data.debito);
            }
            if (response.data.credito_aggiornato) {
              context.commit("update_contabile", response.data.credito_aggiornato);
            }
            if (response.data.fattura) {
              context.commit("update_contabile", response.data.fattura);
            }
            if (response.data.debiti_aggiornati) {
              response.data.debiti_aggiornati.forEach((debito) => {
                context.commit("update_contabile", debito);
              });
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    elimina_tutte_allocazioni_debito(context, id_debito) {
      // "Togli spunta" su un debito coperto: rimuove in blocco tutte le
      // sue coperture invece di doverle eliminare una per una dal dialog.
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/" + id_debito + "/allocazioni";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, { auth: auth, timeout: 15000 })
          .then((response) => {
            if (response.data.debito) {
              context.commit("update_contabile", response.data.debito);
            }
            // Se qualcuna delle coperture rimosse proveniva da un
            // Pagamento Cliente, l'importo è tornato disponibile lì.
            if (response.data.crediti_aggiornati) {
              response.data.crediti_aggiornati.forEach((credito) => {
                context.commit("update_contabile", credito);
              });
            }
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    // Azzera il residuo ancora erodibile di un credito (Pagamento Cliente
    // o Fattura Anticipata) senza bisogno di un debito reale che lo eroda
    // — per il caso in cui quella parte non verrà mai consumata.
    estingui_credito(context, id) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/" + id + "/estingui_credito";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, {}, { auth: auth, timeout: 15000 })
          .then((response) => {
            context.commit("update_contabile", response.data);
            resolve(response.data);
          })
          .catch((error) => reject(error));
      });
    },
    fetch_crediti_disponibili_cliente(context, iva) {
      let url =
        process.env.VUE_APP_API_ROOT + "/contabili/crediti_disponibili/cliente/" + iva;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    // Riepilogo per cliente di quanto ancora aperto/disponibile, SENZA
    // vincolo di periodo (round 65-octodecies) — vedi
    // get_aperture_riepilogo sul backend per il perché.
    fetch_aperture_riepilogo(context) {
      let url = process.env.VUE_APP_API_ROOT + "/contabili/aperture/riepilogo";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    fetch_debiti_aperti_cliente(context, { iva, verde, soloVergini }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/contabili/debiti_aperti/cliente/" +
        iva +
        "?verde=" +
        (verde ? "true" : "false") +
        (soloVergini ? "&solo_vergini=true" : "");
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .get(url, { auth: auth })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
  },
};
